module.exports = __webpack_public_path__ + "img/cecilia-bolan.c7af935f.jpg";